import { useState } from 'react'
import { NavLink, Outlet, useNavigate } from 'react-router-dom'
import { useAuth } from '../features/auth/AuthContext'
import { Logo } from './Logo'

const ownerLinks = [
  ['/app', 'Overview', '⌂'], ['/app/items', 'My items', '◇'], ['/app/tags', 'QR tags', '▦'], ['/app/reports', 'My reports', '⌕'],
  ['/app/messages', 'Messages', '○'], ['/app/notifications', 'Notifications', '◌'], ['/app/settings', 'Settings', '⚙'],
] as const
const adminLinks = [
  ['/admin', 'Overview', '⌂'], ['/admin/users', 'Users', '♙'], ['/admin/reports', 'Posts', '⌕'], ['/admin/abuse', 'Safety queue', '△'],
  ['/admin/tags', 'QR tags', '▦'], ['/admin/plans', 'Plans', '◫'], ['/admin/audit', 'Audit log', '≡'],
] as const

export function AppLayout({ admin = false }: { admin?: boolean }) {
  const [open, setOpen] = useState(false)
  const { user, logout } = useAuth()
  const navigate = useNavigate()
  const links = admin ? adminLinks : ownerLinks
  return <div className="dashboard-shell">
    <aside className={open ? 'sidebar open' : 'sidebar'}>
      <div className="sidebar-brand"><Logo /><button className="sidebar-close" onClick={() => setOpen(false)} aria-label="Close menu">×</button></div>
      <p className="sidebar-label">{admin ? 'Administration' : 'My FindBack'}</p>
      <nav className="side-nav" aria-label={admin ? 'Administration' : 'Account'}>{links.map(([to, label, icon]) => <NavLink key={to} to={to} end={to === (admin ? '/admin' : '/app')} onClick={() => setOpen(false)}><span aria-hidden="true">{icon}</span>{label}</NavLink>)}</nav>
      {user?.role === 'admin' && <NavLink className="mode-switch" to={admin ? '/app' : '/admin'}>{admin ? '← Owner dashboard' : 'Admin console →'}</NavLink>}
      <div className="sidebar-user"><div className="avatar">{user?.name?.charAt(0).toUpperCase()}</div><div><strong>{user?.name}</strong><span>{user?.email}</span></div><button onClick={async () => { await logout(); navigate('/') }}>Sign out</button></div>
    </aside>
    {open && <button className="sidebar-scrim" onClick={() => setOpen(false)} aria-label="Close menu" />}
    <div className="dashboard-main"><header className="dashboard-topbar"><button className="dashboard-menu" onClick={() => setOpen(true)} aria-label="Open menu">☰</button><span className="topbar-title">{admin ? 'Admin console' : 'Owner dashboard'}</span><NavLink to="/reports">Public reports</NavLink></header><main id="main-content" className="dashboard-content"><Outlet /></main></div>
  </div>
}
